var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["gfu-info-hero _jc-c", _vm.rootClasses] }, [
    _c("div", { staticClass: "gfu-info-hero__cover" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gfu-info-hero__content" },
      [
        _vm._t("title", function () {
          return [
            _c(
              "h2",
              {
                staticClass:
                  "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4",
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                ),
              ]
            ),
          ]
        }),
        _vm._v(" "),
        _vm._t("description", function () {
          return [
            _vm._v("\n            " + _vm._s(_vm.description) + "\n        "),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }